module.exports = __webpack_public_path__ + "img/welfare-btn-bg.e22200b2.png";